import { Component, Input, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Http } from '@angular/http';
import { TranslateService } from "@ngx-translate/core";
import { sortBy } from 'lodash';
import * as moment from 'moment';
import { NgProgress } from "ngx-progressbar";
import { Observable } from 'rxjs/Observable';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { AccessLevel } from "../../common/enums/access-level.enum";
import { Permission } from "../../common/enums/permission.enum";
import { CacheKey } from "../../shared/constants/cachekey.constants";
import { CommonConstant } from "../../shared/constants/common.constants";
import { Country } from "../../shared/interface/country.interface";
import { StoreConfig } from "../../shared/interface/StoreConfig.interface";
import { UserInfo } from "../../shared/interface/user-info.interface";
import { CacheService } from "../../shared/services/cache.service";
import { CommonService } from "../../shared/services/common.service";
import { MessageService } from "../../shared/services/message.service";
import { Utils } from "../../shared/Utils/utils";
import { CommonMessage } from "../common/common-messages";
import { MemberType } from "../common/constants";
import { OperatingCountryEnums } from "../enums/countries.enums";
import { DisputeReason } from "../enums/dispute-reason.enum";
import { NotificationType } from '../enums/notification-types.enum';
import { Status } from "../enums/ticket-status.enum";
import { DisputeTypesEnums, Priority, SourceType, SubtypesEnums, TicketType } from '../enums/ticket-type.enum';
import { BusinessEntity } from "../interface/businessentity";
import { OrderDetailInformation } from "../interface/order-detail-info";
import { OrderInfoForNavigation } from "../interface/order-info-navigate";
import { ProductInformation } from "../interface/product-info";
import { ShippingInformation } from "../interface/shipping-info";
import { CopyToSearchResponse, CopyToUserResponse } from '../interface/ticketingsystem/copy-to-search-response.interface';
import { CopyToUser } from '../interface/ticketingsystem/copy-to-users.interface';
import { DisputeOrderInfo } from "../interface/ticketingsystem/dispute-order-info";
import { DistributorInfo } from "../interface/ticketingsystem/distributor-info";
import { CreateTicketRequest } from "../interface/ticketingsystem/ticket-create";
import { DeleteModal } from "../models/delete-modal";
import { TicketTabInfo } from "../models/tickets-tab.model";
import { CustomerService } from "../services/customer.service";
import { DepartmentService } from "../services/department.service";
import { OrderService } from "../services/order.service";
import { DateConstants } from '../constants/date.constants';
import { DisplayNameFormatPipe } from "../../common/pipes/display-name-format.pipe";



@Component({
    selector: "create-dispute-ticket",
    templateUrl: "../templates/template1/views/dispute-ticket-create.component.html",
    styleUrls: [
        "../templates/template1/themes/default/css/ticket.less"
    ],
    providers:[DisplayNameFormatPipe]
})
export class CreateDisputeTicket implements OnInit {

    @Input() distributorInfo: DistributorInfo;
    @Input() webOrderID: string;
    @Input() tabIndex: number;
    @Input() countryCode: string;

    FBOManageTicketPermissions: any[] = [
        Permission.MANAGE_TICKETS_CREATE,
        Permission.MANAGE_DEPARTMENT_TICKETS_ASSIGN,
        Permission.MANAGE_TICKETS_ADD_NOTE_ATTACHMENT,
        Permission.MANAGE_TICKETS_VIEW
    ];
    ManageDepartmentPermissions: any[] = [
        Permission.MANAGE_DEPARTMENT_TICKETS_CLOSE,
        Permission.MANAGE_DEPARTMENT_TICKETS_RE_OPEN,
        Permission.MANAGE_DEPARTMENT_TICKETS_EDIT,
        Permission.MANAGE_DEPARTMENT_TICKETS_SELF_ASSIGN,
        Permission.MANAGE_DEPARTMENT_TICKETS_REASSIGN,
        Permission.MANAGE_DEPARTMENT_TICKETS_ASSIGN
    ];
    ticketCreateForm: FormGroup;
    isSubmitted: boolean = false;
    userInfo: UserInfo;
    isTicketCreate: any;
    isTicketAssign: any;
    isTicketAddorAttachment: any;
    isTicketView: any;
    businessEntities: BusinessEntity[] = [];
    countries: any;
    uploader: any;
    ticketTypes: any[];
    disputeTypes: any[];
    ticketResponse: any;
    uploadResponse: any = [];
    sourceTypes: any[];
    sourceTypesEnum: any = SourceType;
    locationTypes: any;
    ticketPriorities: any[];
    ticketStatus: any[];
    subTypes: any[];
    orderType: any;
    departments: any[];
    users: any[];
    disputeReasons: any[];
    isTicketAssignPermission: boolean = false;
    orderInfo: OrderDetailInformation;
    productsInfo: Array<ProductInformation>;
    subTypeEnums: any = SubtypesEnums;
    disputeTypeEnums: any = DisputeTypesEnums;
    items: any[] = [];
    attachmentsLength:number;
    attachmentWarning: DeleteModal;
    clearFormAlert: DeleteModal;
    disptueReason:string;
    enableReason:boolean = false;
    formInvalid:boolean = false;
    qtyWarning: DeleteModal;
    disableCreate:boolean;
    inValidOrderNumber:boolean;
    validWebOrderNumber:boolean;
    elementoffsetValue:number;
    momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;
    showDatePicker = false;
    storeInfo:StoreConfig;
    operatingCountryId: number;
    customerServiceAccessLevelId: number= AccessLevel.Customer_Service;
    contactName: string;
    contactNumber: string;
    phoneNumberFormat: string;
    countryPhoneFormat: string;
    orderInfoFornavigation: OrderInfoForNavigation;
    allCountries: any;
    IsoCodeThree: string;
    subjectMaxLength :any = {maxLength:500};

     constructor( private _translatePipe: TranslateService, private _commonService: CommonService, private _customerservice: CustomerService,
        private messageService: MessageService, private ngProgress: NgProgress, private _formbuilder: FormBuilder, private _cacheService: CacheService,
        private departmentService: DepartmentService, private _messageService: MessageService, private _orderservice: OrderService, private _DisplayNamePipe: DisplayNameFormatPipe,
        private _http: Http) {

    }
    ngOnInit(): void {
        if (this.distributorInfo && this.distributorInfo.contactNumber) {
            this.distributorInfo.contactNumber = this.distributorInfo.contactNumber.replace(/\D/g, '');
        }
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.contactName = this._DisplayNamePipe.transform(this.distributorInfo);
        this.contactNumber = this.distributorInfo.contactNumber;
        this.getStoreConfig();
    }

       getStoreConfig(): void {
        this._orderservice.getStoreInfo(this.countryCode? this.countryCode : CommonConstant.Default_Country).subscribe(response => {
            if (response) {
                this.storeInfo = response;
                this.buildForm();                
                this.getSourceTypes();
                this.getTicketPriorities();
                this.getTicketStatus();
                this.getDisputeTypes();
                this.getTicketTypesAndSubTypes();
                this.getDisputeReasons();
                this._commonService.getUserInformation(this.userInfo.userName).subscribe(data => {        
                    if (data) {
                        this._cacheService.set(CacheKey.UserInfo, data);
                        this.userInfo = data;
                        this.isTicketCreate = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[0] + "]"), AccessLevel.Customer_Service);
                        this.isTicketAssign = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[1] + "]"), AccessLevel.Customer_Service);
                        this.isTicketAddorAttachment = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[2] + "]"), AccessLevel.Customer_Service);
                        this.isTicketView = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[3] + "]"), AccessLevel.Customer_Service);
                        this.getBusinessEntities();
                    }
                });     
                this.attachmentWarning = new DeleteModal(this.noAction.bind(this),
                this.noAction.bind(this), this.noAction.bind(this));
                this.clearFormAlert = new DeleteModal(this.clearForm.bind(this),
                this.noAction.bind(this), this.noAction.bind(this));
                this.webOrderID ? this.getRecentOrderInformation():'';
                this.qtyWarning = new DeleteModal(this.proceedToSave.bind(this),
                this.noAction.bind(this), this.noAction.bind(this));
                this.qtyWarning.viewActionButtons = true;
            }
        });
    }


    proceedToSave() {
        let createTicketValues: any = this.ticketCreateForm.getRawValue();
        let ticket = new CreateTicketRequest();
        ticket.sourceId = createTicketValues.source;
        ticket.callerName = createTicketValues.callerName;
        ticket.operatingCountryId = createTicketValues.operatingCountry;
        ticket.typeId = createTicketValues.ticketType;
        ticket.subTypeId = createTicketValues.subType;
        ticket.description = createTicketValues.description;
        ticket.disputeTypeId = Number(createTicketValues.disputeType);
        ticket.departmentId = +createTicketValues.department;
        ticket.priorityId = createTicketValues.priority;
        ticket.dueDate = createTicketValues.dueDate ? Utils.convertToSpecificDateFormat(createTicketValues.dueDate, DateConstants.DOBFormat) : null;
        ticket.subject = createTicketValues.subject;
        ticket.assignedToId = createTicketValues.assignTo;
        ticket.memberId  = this.distributorInfo.distributorId ? this.distributorInfo.distributorId : "";
        ticket.distributorName = this.distributorInfo.name;
        ticket.agentEmail = this.userInfo.email;
        ticket.agentName = this.userInfo.firstName+' '+this.userInfo.lastName;
        ticket.ticketLink=window.location.href;
        ticket.countryId = this._commonService.getCountry(this.IsoCodeThree, true);
        if(this.users && ticket.assignedToId){
          const  assignedToUser=  this.users.find(item=>item.id=== +ticket.assignedToId);
          if(assignedToUser){
            ticket.assignedToEmail= assignedToUser.email;
          }             
        }
        if(this.distributorInfo.memberType === MemberType.RETAIL || this.distributorInfo.memberType === 'R'
          || this.distributorInfo.memberType.toUpperCase() === MemberType.RETAILCUSTOMER )
            {
                ticket.memberType = MemberType.RETAIL;
            }
            else if(this.distributorInfo.memberType === MemberType.GUEST || this.distributorInfo.memberType === 'G')
            {
                ticket.memberType = MemberType.GUEST;
            }
            else if(this.distributorInfo.memberType === MemberType.FPC)
            {
                ticket.memberType = MemberType.FPC;
            }
            else{
            ticket.memberType = MemberType.FOB;
            }
        ticket.userId = this.userInfo.userId;
        ticket.firstName = this.userInfo.firstName;
        ticket.lastName = this.userInfo.lastName;
        if(createTicketValues.source === SourceType.Email){
            ticket.sourceIdentifierValue = createTicketValues.sourceIdentifierValue;
        } 
        else if(createTicketValues.source === SourceType.Phone){
            ticket.sourceIdentifierValue = createTicketValues.sourceIdentifierValue;
        } 
        ticket.statusId = createTicketValues.status;
        ticket.orderId = createTicketValues.webOrderNumber;
        if(+(ticket.disputeTypeId) === DisputeTypesEnums.Dispute_Individual_Order){
            let disputedOrders:any = this.addDisputeProducts();
            ticket.disputes = disputedOrders;
        }
        else if(+(ticket.disputeTypeId) === DisputeTypesEnums.Dispute_Total_Order){
            ticket.orderReasonReasonId = createTicketValues.disputeReason;
        }
        this.enableReason ?ticket.orderReasonNotes = createTicketValues.orderReasonNotes:'';
        ticket = this.mapCopyToUsers(ticket);
        this.saveTicket(ticket);
    }

    /**
     * @description This method used to map copyTo users in ticket model
     * @date 2019-11-19
     * @memberof DisputeTicket
    */
   mapCopyToUsers(ticket: CreateTicketRequest): CreateTicketRequest {
    ticket.copyToUsers = [];
    if (this.ticketCreateForm.value.copyTo && this.ticketCreateForm.value.copyTo.length) {
        this.ticketCreateForm.value.copyTo.forEach(item => {
            const user: CopyToUser = {
                userId: item.userId,
                username: item.username,
                firstName: item.firstName,
                lastName: item.lastName
            };
            ticket.copyToUsers.push(user);
        });
    }
    return ticket;
}


    disputeTicketTransformDate(date: any) {
        const dateMomentObj = Utils.convertToSpecificDateFormat(date, DateConstants.DateFormat);
        if (dateMomentObj) {
            if (this.ticketCreateForm.controls['dueDate'].valid) {
                this.ticketCreateForm.controls['dueDate'].setValue(moment(dateMomentObj, 'DD-MMM-YYYY'));
            }
        } else {
            this.ticketCreateForm.controls['dueDate'].setValue('');
        }
    }
    /**
      * Build form
      */
    buildForm() {
        this.ticketCreateForm = this._formbuilder.group(
            {
                webOrderNumber: [this.webOrderID ? this.webOrderID :'', Validators.required],
                operatingCountry: ['', Validators.required],
                country: ['', Validators.required],
                department: ['', Validators.required],
                source: [SourceType.Phone, Validators.required],
                callerName: [this.contactName ? this.contactName : '', Validators.required],
                ticketType: [{ value: '', disabled: true }, Validators.required],
                assignTo: [''],
                sourceIdentifierValue: [this.contactNumber ? this.contactNumber : '', [Validators.required, Utils.PhoneNumValidationRule, Utils.PhoneNumLengthValidationRule]],
                priority: ['', Validators.required],
                subType: ['', Validators.required],
                disputeType: [DisputeTypesEnums.Dispute_Total_Order, Validators.required],
                subject: ['', [Validators.required, Validators.maxLength(this.subjectMaxLength.maxLength)]],
                description: ['', Validators.required],
                dueDate: [{ value: '', disabled: true }],
                disputeReason: ['', Validators.required],
                items: this._formbuilder.array([]),
                orderReasonNotes:[''],
                filePath: [new Array<string>()],
                status: [Status.New, Validators.required],
                copyTo: [[]]
            });
    }
    getBusinessEntities() {
        this._customerservice.getAllBusinessEntities().subscribe(response => {
            if (response) {
                this.businessEntities = response;
                this.getAllowedCountries();
            }
        });
    }
    getAllowedCountries() {
        let countryIds: any = [];
        if (!this.userInfo.hasSystemRole) {
            if (this.userInfo.allowedOperatingCountries) {
                countryIds = this.userInfo.allowedOperatingCountries.split(",");
                if (this.userInfo.privileges.departments) {
                    countryIds.push.apply(countryIds, this.userInfo.privileges.departments.map(function (a) { return a.allowedOperatingCountries; }));
                }
    
                countryIds = countryIds ? countryIds : [];
                if (countryIds.length > 0) {
                    var ids = countryIds;
                    this.countries = this.businessEntities.filter(function (item) {
                        return ids.indexOf(item.id + "") != -1;
                    });
                }
            }
            else {
                this.countries = this.businessEntities;
            }
        }
        else {
            this.countries = this.businessEntities;
        }
        this.countries.sort(function (item1, item2) {
            var country1 = item1.name.toLowerCase(), country2 = item2.name.toLowerCase()
            if (country1 < country2) //sort string ascending
                return -1
            if (country1 > country2)
                return 1
            return 0
        });
        const usaInfo = this.countries.find((country: any) => country.id === OperatingCountryEnums.USA);
        if (usaInfo) {
            this.countries.splice(this.countries.indexOf(usaInfo), 1);
            this.countries.splice(0, 0, usaInfo);
        }
        this.loadDefaultOperatingCountry();
    }

    loadDefaultOperatingCountry(): void {
        if (this.countries && this.countries.length > 0) {
            const orderCreatedForCountry = this.countries.find((country:any) => country.value === this.countryCode);
            const defaultCountry: Country = orderCreatedForCountry? orderCreatedForCountry :  this.countries[0];
            this.count = 0;
            this.attachmentsLength = 0;
            this.ticketCreateForm.controls['operatingCountry'].setValue(defaultCountry.id);
            this.operatingCountryChange(defaultCountry.id);
            this.operatingCountryId = defaultCountry.id;
            this.uploader = this._customerservice.getFileUploader();
            this.uploader.onErrorItem = () => this.onErrorItem();
            this.uploader.onSuccessItem = (item: any, response: any, status: any, headers: any) => this.onSuccessItem(response);
        }
    }

    getTicketTypesAndSubTypes() {
        this.ticketTypes = [];
        const operatingCountry = this.ticketCreateForm.controls['operatingCountry'].value;
        if (operatingCountry) {
            this.departmentService.getTicketTypesAndSubTypes(operatingCountry).subscribe(response => {
            if (response) {
                    this.ticketTypes = response.filter((type: any) => type.value === TicketType.Order);
                    if (this.ticketTypes && this.ticketTypes.length > 0) {
                        this.orderType = this.ticketTypes.find(item => item.value === TicketType.Order);
                        this.subTypes = this.orderType.subTypes;
                        this.ticketCreateForm.controls['ticketType'].setValue(this.orderType.id);
                    }
                }
            });
        }
    }

    /**
 * failed to upload file
 * @param item 
 * @param response 
 * @param status 
 * @param headers 
 */
    onErrorItem(): any {
        this.ngProgress.done();
        this._commonService.createNotification("", "Failed to upload document. Please try after sometime ", NotificationType.ERROR);
    }
    /**
         * On Successful upload of file
         * @param item 
         * @param response 
         * @param status 
         * @param headers 
         */
    count: number = 0;
    onSuccessItem(response: string): any {
        if (response) {
            let res = JSON.parse(response);
            let fileDetails = {
                "userId": this.userInfo.userId,
                "fileName": this.uploader.queue[this.count].file.name.substr(0,95),
                "url": res.url,
                "eTag": res.eTag,
                "key": res.key
            }
            this.uploadResponse.push(fileDetails);
            this.count++;
            if (this.uploader.queue.length === this.count) {
                //Save Attachment
                this.saveAttachments(this.uploadResponse);
            }

        }
        else {
            this._commonService.createNotification("", "File Not uploaded", NotificationType.ERROR);
        }
        this.ngProgress.done();
    }
    saveAttachments(attachments: any) {
        this._customerservice.saveAttachments(attachments, this.ticketResponse.id).subscribe(response => {
            if (response) {
                let res = response;
                let addedNotification: any = this._translatePipe.get("Ticket " + this.ticketResponse.ticketNumber + " has been Created successfully");
                this._commonService.createNotification("", addedNotification.value , NotificationType.SUCCESS);
                this.closeTab();
            }
        });
    }

    getSourceTypes() {
        this._customerservice.getSourceTypes().subscribe((response) => {
            if (response) {
                this.sourceTypes = response;
            }
        });
    }

    clearForm() {
        this.isSubmitted = false;
        this.formInvalid = false;
        this.ticketCreateForm.controls['webOrderNumber'].setValue(this.webOrderID);
        this.ticketCreateForm.controls['source'].setValue(SourceType.Phone);
        this.ticketCreateForm.controls['sourceIdentifierValue'].setValue(this.distributorInfo.contactNumber);
        this.ticketCreateForm.controls['sourceIdentifierValue'].setValidators(null);
        this.ticketCreateForm.controls['callerName'].setValue(this.distributorInfo.name);
        this.ticketCreateForm.controls['dueDate'].setValue('');
        this.showDatePicker = false;
        this.ticketCreateForm.controls['dueDate'].disable();
        this.ticketCreateForm.controls['subType'].setValue(SubtypesEnums.Dispute);
        this.ticketCreateForm.controls['disputeType'].setValue(DisputeTypesEnums.Dispute_Total_Order);
        this.ticketCreateForm.controls['department'].setValue('');
        this.ticketCreateForm.controls['assignTo'].setValue('');
        if (this.orderType && this.orderType.id) {
            this.ticketCreateForm.controls['ticketType'].setValue(this.orderType.id);
        }
        this.ticketCreateForm.controls['priority'].setValue(Priority.Medium);
        this.ticketCreateForm.controls['disputeReason'].setValue('');
        this.ticketCreateForm.controls['orderReasonNotes'].setValue('');
        this.ticketCreateForm.controls['orderReasonNotes'].disable();
        this.ticketCreateForm.controls['description'].setValue('');
        this.ticketCreateForm.controls['copyTo'].setValue([]);
        this.ticketCreateForm.controls['subject'].setValue('Dispute Order ' + this.webOrderID);
        if (!this.webOrderID) {
            this.productsInfo=null;
        }
        this.loadDefaultOperatingCountry();
    }
    getTicketPriorities() {
        this._customerservice.getTicketPriorities().subscribe((response) => {
            if (response) {
                this.ticketPriorities = response;
                this.setDefaultPriority();
            }
        });
    }

    getTicketStatus() {
        this._customerservice.getTicketStatus().subscribe((response) => {
            if (response) {
                this.ticketStatus = response;
                this.ticketStatus = sortBy(this.ticketStatus, 'value');
            }
        });
    }

    // get location types and display when product is selected
    getLocationTypes() {
        this._customerservice.getLocationTypes().subscribe(response => {
            if (response) {
                this.locationTypes = response;
            }
        });
    }
    /*
    set medium as default priority..
    */
    setDefaultPriority() {
        if (this.ticketPriorities && this.ticketPriorities.length > 0) {
            this.ticketCreateForm.controls['priority'].setValue(Priority.Medium);
        }
    }
    operatingCountryChange(id: any, isCountryChange ?: Boolean) {
        if (id) {
            if (this.countries && this.countries.length) {
                const selectedCountry = this.countries.find((country: Country) => country.id === +id);
                if (selectedCountry) {
                    this.getAllCountries(selectedCountry.value);
                    this.phoneNumberFormat = this._commonService.getPhoneNumberFormatByCountryCode(selectedCountry.value);
                    this.countryPhoneFormat = this.phoneNumberFormat ;
                }
            }
            this.ticketCreateForm.controls['subType'].setValue('');
            this.ticketCreateForm.controls['department'].setValue('');
            this.ticketCreateForm.controls['assignTo'].setValue('');
            this.operatingCountryId = +id;
            this.getTicketTypesAndSubTypes();
            this.uploader = this._customerservice.getFileUploader();
            this.uploader.onErrorItem = () => this.onErrorItem();
            this.uploader.onSuccessItem = (item: any, response: any, status: any, headers: any) => this.onSuccessItem(response);
            this.getDepartments();
            if (this.ticketCreateForm.controls['webOrderNumber'].value && isCountryChange) {
                this.getRecentOrderInformation();
            }
        }
    }
    getSubTypes(event: any) {
        let ticketTypeId = +event;
        this.subTypes = [];
        if (ticketTypeId) {
            let types: any[] = JSON.parse(JSON.stringify(this.ticketTypes))
            this.ticketCreateForm.controls['subType'].setValue('');
            this.subTypes = types.find(item => item.id === ticketTypeId).subTypes;
        }
    }
    
    /**
     * get Departments By oprating Country
     */
    getDepartments(): void {
        if (this.ticketCreateForm.controls["operatingCountry"].value) {
            this._customerservice.getAllDepartmentsByOperatingCountryId(+this.ticketCreateForm.controls["operatingCountry"].value).subscribe(response => {
                if (response) {
                    this.departments = response;
                    this.departments.sort(function (item1, item2) {
                        var dept1 = item1.value.toLowerCase(), dept2 = item2.value.toLowerCase()
                        if (dept1 < dept2) //sort string ascending
                            return -1
                        if (dept1 > dept2)
                            return 1
                        return 0
                    });
                    this.ticketCreateForm.controls['department'].setValue('');
                    if (this.departments && this.departments.length === 1) {
                        this.ticketCreateForm.controls['department'].setValue(this.departments[0].id);
                        this.getAssignedUsersByDepartments(this.departments[0].id);
                    }
                } else {
                    this.departments = [];
                    this.ticketCreateForm.controls['department'].setValue('');
                    this.getAssignedUsersByDepartments("");
                }
            });
        }
    }
    disputeTypeChange(event: any) {
        const disputeTypeId = +event;
        this.enableReason = false;
        this.ticketCreateForm.controls['orderReasonNotes'].setValidators(null);
        this.ticketCreateForm.controls['orderReasonNotes'].updateValueAndValidity();
        if(+this.ticketCreateForm.controls['disputeType'].value === DisputeTypesEnums.Dispute_Individual_Order){
            this.ticketCreateForm.controls['disputeReason'].setValidators(null);
            this.ticketCreateForm.controls['disputeReason'].setValue('');
            this.ticketCreateForm.controls['orderReasonNotes'].setValue('');
        }
        else{
            this.ticketCreateForm.controls['disputeReason'].setValidators(Validators.required);
            this.ticketCreateForm.controls['orderReasonNotes'].setValue('');
        }
        this.ticketCreateForm.controls['disputeReason'].updateValueAndValidity();
        if (disputeTypeId) {
            if (this.ticketCreateForm.controls['webOrderNumber'].valid && this.orderInfo) {                 
                if (+disputeTypeId === DisputeTypesEnums.Dispute_Individual_Order) {
                    const arr = <FormArray>this.ticketCreateForm.controls.items;
                    arr.controls = [];
                    this.ticketCreateForm.controls['items'].updateValueAndValidity();
                    this.items = this.ticketCreateForm.get('items') as any;
                    for (let index = 0; index < this.productsInfo.length; index++) {
                        this.items.push(this.createItemNumberGroup(this.productsInfo[index]));
                    }
                }else {
                    const arr = <FormArray>this.ticketCreateForm.controls.items;
                    arr.controls = [];
                    this.ticketCreateForm.controls['items'].updateValueAndValidity();
                }
            }
        }
    }
    getAssignedUsersByDepartments(event: any) {
        let departmentId = +event;
        this.ticketCreateForm.controls['assignTo'].setValue('');
        // as per JIRA #PS2021-1080
        // if (!this.userInfo.hasSystemRole) {
        //     this.isTicketAssignPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.ManageDepartmentPermissions[5] + "]"), AccessLevel.Department, departmentId);
        // } 
       // else {
            this.isTicketAssignPermission = true;
       // }

        // if (!this.isTicketAssignPermission) {
        //    this.ticketCreateForm.controls["assignTo"].disable();
        //     this.users = [];
        //     this.ticketCreateForm.controls['assignTo'].setValue('');
        //     this.ticketCreateForm.controls["dueDate"].setValue('');
        //     this.showDatePicker = false;
        //     this.ticketCreateForm.controls["dueDate"].disable();
        // } else {
            this.ticketCreateForm.controls["assignTo"].enable();
            if (departmentId) {
                this._customerservice.getAssignedUsersByDepartments(departmentId).subscribe(response => {
                    if (response) {
                        this.users = response;
                        if (this.users && this.users.length > 0) {
                            this.users = this.users.sort(function (a, b) {
                                return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
                            });
                        }
                       
                        this.assignToChange();
                    } else {
                        this.users = [];
                        this.ticketCreateForm.controls['assignTo'].setValue('');
                    }
                });
            }
        // }
        if (departmentId === 0) {
            this.ticketCreateForm.controls["assignTo"].enable();
            this.users = [];
            this.ticketCreateForm.controls['assignTo'].setValue('');
        }
    }
    
    addDisputeProducts(){
        let disputedOrders: Array<DisputeOrderInfo>;
        disputedOrders = this.ticketCreateForm.getRawValue().items;
        disputedOrders.forEach(item => {
            if(item.include){
                item.alreadyDisputedQuantity = item.alreadyDisputedQuantity + (+item.newDisputedQuantity);
            }
            else{
                item.alreadyDisputedQuantity = 0;
                item.ticketDisputeReasonId = null;
            }
            item.newDisputedQuantity = 0;
            item.createdBy = this.userInfo.userId;
        });
        return disputedOrders;
    }
    createTicket() {
        this.isSubmitted = true;
        this.disableCreate = true;
        const invalidFields:any =  document.querySelectorAll('#Create-DisputeTicket-js .ng-invalid');
        window.scrollTo(this.elementoffsetValue,0)
        if(invalidFields[0]){
            invalidFields[0].focus();
            this.disableCreate = false;
        }

        let createTicketValues: any = this.ticketCreateForm.getRawValue();
        if (createTicketValues.disputeType == DisputeTypesEnums.Dispute_Individual_Order) {
            let individualFormValues: any = createTicketValues.items;
            if (!individualFormValues.filter(res => res.include === true).length) {
                this.formInvalid = true;
                return;
            }
        }
        if (this.ticketCreateForm.valid && this.validWebOrderNumber) {
            let createTicketValues: any = this.ticketCreateForm.getRawValue();    
            let disputes: any = createTicketValues.items;        
            if(disputes.filter(res => res.alreadyDisputedQuantity > res.quantity).length > 0){
                let invalidQtyLineItems = disputes.map(function(res){ if(res.alreadyDisputedQuantity > res.quantity){ return res.itemNumber} }).join();
                this.qtyWarning.toggle = true;
                this.qtyWarning.message = "The number of disputed items for SKU# "+ invalidQtyLineItems +" exceed the original quantity ordered. If this is correct, click Yes to proceed with this dispute.";
                this.disableCreate = false;
            }
            else{
                this.proceedToSave();
            }
        }
        else if(!this.validWebOrderNumber){
            this.orderNotFound();
        }
    }
    saveTicket(ticket: any) {
        this._customerservice.saveTicket(ticket).subscribe(response => {
            if (response) {
                this.isSubmitted = false;
                this.ticketResponse = response;
                this._cacheService.set(CacheKey.ORDERTABREFRESH, true);
                this._messageService.setAuditLogUpdated(true);
                this.disableCreate=false;
                this.messageService.setDisputeTickets(true);
                if (this.uploader.queue.length > 0) {
                    this.uploadFile();
                } else {
                    let addedNotification: any = this._translatePipe.get("Ticket " + this.ticketResponse.ticketNumber + " has been Created successfully");
                    this._commonService.createNotification("", addedNotification.value , NotificationType.SUCCESS);
                    this.closeTab();
                }
            }
        });
    }
    closeTab(){
        let tabinfo = new TicketTabInfo();
        tabinfo.distributorID = this.distributorInfo.distributorId;
        tabinfo.tabIndex = this.tabIndex;
        tabinfo.ticketID = this.ticketResponse.id;     
        tabinfo.ticketNumber = this.ticketResponse.ticketNumber;
        this.messageService.setClosingTabInfo(tabinfo);
    }
    /** *  UPLOAD FILE   ----- BEGIN ----- ************************* */
    /**
     * Upload file
     */
    uploadFile() {
        if (this.uploader && this.uploader.queue.length > 0) {
            this.ngProgress.start();
            let filelength = 0;
            let ticketNumber = this.ticketResponse.id;
            this.uploader.onBuildItemForm = (item: any, form: any) => {
                filelength++;
                item.withCredentials = false;
                item.uploader.authToken = this._customerservice.getAuthorizationToken();
                const fileNameArr = item.file.name.split('.');
                item.file.name = fileNameArr[0] + '_' + ticketNumber + '_' + filelength
                + (fileNameArr.length > 1 ? '.' + fileNameArr[fileNameArr.length - 1] : '');
                form.append('fileName', decodeURIComponent(encodeURIComponent(item.file.name)));
                form.append('path', 'content/customer-service/' + this.operatingCountryId + '/');
            };
            for (let i = 0; i < this.uploader.queue.length; i++) {
                this.uploader.queue[i].upload();
            }
        }
    }
    /**
         * Dispute Reasons
         */
    getDisputeReasons() {
        this._customerservice.getDisputeReasons().subscribe(response => {
            if (response) {
                this.disputeReasons = response;
                this.disputeReasons = sortBy(this.disputeReasons, 'value');
            }
        });
    }
    // dispute type
    getDisputeTypes() {
        this._customerservice.getDisputeTypes().subscribe(response => {
            if (response) {
                this.disputeTypes = response;
                this.disputeTypes = sortBy(this.disputeTypes, 'value');
            }
        });
    }

    createItemNumberGroup(productInfo: ProductInformation): FormGroup {
        return this._formbuilder.group({
            itemNumber: [productInfo.sku],
            quantity: [productInfo.quantity],
            productDescription: [productInfo.productDescription],
            alreadyDisputedQuantity: ['0'],
            newDisputedQuantity: ['0'],
            ticketDisputeReasonId: [''],
            include: new FormControl(false),
            createdBy: [this.userInfo.userId],
            modifiedBy: [""]
        });
    }
    /**
     * Gets fbo / retail oder information from titan
     */
    getRecentOrderInformation(webOrderID?: string) {
        if (this.ticketCreateForm.controls['webOrderNumber'].valid || webOrderID) {
            this.disableCreate = true;
            this.validWebOrderNumber = false;
            this.inValidOrderNumber = false;
            let webOrderId = webOrderID ? webOrderID : this.ticketCreateForm.controls['webOrderNumber'].value;
            webOrderId = webOrderId.toUpperCase();
            webOrderId = webOrderId.trim();
            if (!this.IsoCodeThree && this.countryCode) {
                    this.IsoCodeThree = this.countryCode;
            }
            this._orderservice.getRecentOrderInformation(webOrderId, this.IsoCodeThree).subscribe(response => {
                if (response) {
                    response.orderLineItems =  sortBy(response.orderLineItems, 'itemNumber');
                    if (webOrderId !== response.webOrderId ) {
                        this.getOrderDetails(webOrderId);
                    } else {
                        this.validWebOrderNumber = true;
                        this.getShipMethodInfo(response);
                        this.orderInfoFornavigation=this._customerservice.mapOrderInfoForNavigation(response);
                    }
                }else{
                    this.orderNotFound();
                }
            }, error => {
                this.getOrderDetails(webOrderId);

            });
        }
    }
    getOrderDetails(webOrderId?: string) {
        this._customerservice.getOrderInfoUsingWebOrderNum(webOrderId, this.IsoCodeThree)
        .subscribe((response: OrderDetailInformation) => {
            if (response) {
                if (webOrderId !== response.webOrderNumber && webOrderId !== response.orderNumber) {
                    this.orderNotFound();
                    return;
                }
                this.validWebOrderNumber = true;
                this.orderInfo = response;
                this.orderInfoFornavigation=this._customerservice.mapOrderInfoForNavigationForNonTitanOrder(response);
                this.productsInfo = response.productInfo;
                this.orderInfo.address=this._customerservice.mapShippingAddress(this.orderInfo);
              
                this.productsInfo = sortBy(this.productsInfo, 'itemNumber');
                this.setOrderInfoToForm(webOrderId);
               
            }else{
                this.orderNotFound();
            }
        }, error => {
            this.disableCreate = false;
            this.orderNotFound();
        });
    }
       /**
     * get Ship method Info
     */
    getShipMethodInfo(orderInfo:any){
        if(orderInfo.orderShippings.length > 0 && orderInfo.orderShippings[0].shipMethodId && orderInfo.storeId){
            let shipMethodId = orderInfo.orderShippings[0].shipMethodId;
            let storeId = orderInfo.storeId;
            this._customerservice.getShipMethodInfo(storeId ,shipMethodId).subscribe(response => {
                if (response) {
                   this.orderInfo = this.mapOrderResponseToModel(orderInfo, response.shippingMethodDisplayName);
                   this.productsInfo = this.orderInfo.productInfo;
                   this.setOrderInfoToForm(orderInfo.webOrderId);
                }
                else{
                    this.orderInfo = this.mapOrderResponseToModel(orderInfo);
                    this.productsInfo = this.orderInfo.productInfo;
                   this.setOrderInfoToForm(orderInfo.webOrderId);
                }
            },error=>{
                this.orderInfo = this.mapOrderResponseToModel(orderInfo);
            this.productsInfo = this.orderInfo.productInfo;
            this.setOrderInfoToForm(orderInfo.webOrderId);
            });
        }
        else{
            this.orderInfo = this.mapOrderResponseToModel(orderInfo);
            this.productsInfo = this.orderInfo.productInfo;
            this.setOrderInfoToForm(orderInfo.webOrderId);
        }
        
    }
    /**
     * map order response from titan to order model
     */
    mapOrderResponseToModel(orderResponse:any, shipMethodName?:string):OrderDetailInformation{
        let orderInfo = new OrderDetailInformation();
        if (orderResponse && orderResponse.createdDate) {
            orderInfo.orderDate = moment.utc(orderResponse.createdDate)
                .utcOffset(this.storeInfo.timeZoneOffset).format('DD-MMM-YYYY HH:mm:ss');
        }
        orderInfo.orderNumber = orderResponse.orderNumber || '';
        orderInfo.productInfo = [];
        orderInfo.addresses=orderResponse.addresses;
        if(orderInfo && orderInfo.addresses && orderInfo.addresses.length>0){
        orderInfo.address= orderInfo.addresses[0];
        }
        orderInfo.shippingInfo = new ShippingInformation();
        orderInfo.shippingInfo.shippingMethod = shipMethodName || 'NA';
        if (orderResponse && orderResponse.orderShippings && orderResponse.orderShippings.length > 0) {
            orderInfo.shippingInfo.warehouseName = orderResponse.orderShippings[0].distributionCenter;
            orderInfo.deliveryPreferenceId = orderResponse.orderShippings[0].deliveryPreferenceId;
        } else {
            orderInfo.shippingInfo.warehouseName = null;
        }
        orderInfo.webOrderNumber = orderResponse.webOrderId;
        orderResponse.orderLineItems.forEach((product:any) => {
            let productInfo = new ProductInformation();
            productInfo.itemNumber = product.itemNumber;
            productInfo.cc = product.unitQualificationValue;
            productInfo.price = product.unitPaidPrice;
            productInfo.productDescription = product.productName;
            productInfo.quantity = product.quantity;
            productInfo.sku = product.itemNumber;
            orderInfo.productInfo.push(productInfo);
        })
        orderInfo.productInfo = sortBy(orderInfo.productInfo, 'itemNumber');
        return orderInfo;
    }
    /**
     * 
     */
    setOrderInfoToForm(webOrderId) {
        const arr = <FormArray>this.ticketCreateForm.controls.items;
        arr.controls = [];
        this.ticketCreateForm.controls['items'].updateValueAndValidity();
        if (this.orderInfo.shippingInfo && this.orderInfo.shippingInfo.address && this.orderInfo.shippingInfo.address.country) {
            let countryInfo = this.countries.find((item: any) => item.value === this.orderInfo.shippingInfo.address.country);
            if (countryInfo) {
                this.ticketCreateForm.controls['operatingCountry'].setValue(countryInfo.id);
                this.operatingCountryChange(countryInfo.id);
            }
        }
        else{
            this.ticketCreateForm.controls['disputeType'].value ? this.disputeTypeChange(this.ticketCreateForm.controls['subType'].value) : '';
            this.getDepartments();
        }
        this.ticketCreateForm.controls["subject"].setValue("Dispute Order " + webOrderId);
        this.disableCreate = false;
    }
    /**
     * message when order not found
     */
    orderNotFound() {
        this.disableCreate = true;
        this.inValidOrderNumber=true;
        let addedNotification: any = this._translatePipe.get("Order not found");
        this._commonService.createNotification("", addedNotification.value ,  NotificationType.ERROR);
        this.ticketCreateForm.controls["subject"].setValue("");
    }

    /* on change of Qty */
    selectItem(event: any, index: number, maxQty: number) {
        let inputChar = event.charCode ? String.fromCharCode(event.charCode) : event.target.value;
        const items: any = this.ticketCreateForm.get('items');
        if (inputChar && Utils.validateNumericCharacterRule(inputChar) && (+inputChar > 0)) {
            this.formInvalid = false;
            this.markAsSelected(index, items);
        }
        else {
            +inputChar === 0 ? '' : event.preventDefault();
            if (event.target.value === "" || event.target.value === null || +event.target.value === 0 || +inputChar === 0) {
                this.deselectLineItem(index, items);
            }
        }
    }

    markAsSelected(index: number, items: any) {
        items.controls[index].controls['include'].setValue(true);
        items.controls[index].controls['ticketDisputeReasonId'].setValidators([Validators.required]);
        items.controls[index].controls['ticketDisputeReasonId'].updateValueAndValidity();
        this.individualOrderReasonChange(index);

    }

    deselectLineItem(index: number, items: any) {
        items.controls[index].controls['include'].setValue(false);
        items.controls[index].controls['ticketDisputeReasonId'].setValidators(null);
        items.controls[index].controls['ticketDisputeReasonId'].updateValueAndValidity();
        this.individualOrderReasonChange(index);
    }

    /*
   when we use backspace and the input is empty, deselect the item
   */
    onBackspace(event: any, index: number) {
        const items: any = this.ticketCreateForm.get('items');
        if (event.target.value === "" || +event.target.value === 0) {
            this.deselectLineItem(index, items);
        }
    }
    /*
   change Quantity
   */
    changeQty(sign:any, maxQty:number, index:number){
         
        const items: any = this.ticketCreateForm.get('items');
        if(sign === "+"){
            items.controls[index].controls['alreadyDisputedQuantity'].setValue(parseInt(items.controls[index].controls['alreadyDisputedQuantity'].value) + 1);
            (+(items.controls[index].controls['alreadyDisputedQuantity'].value)) > 0 ? this.markAsSelected(index, items):'';
        }
        else if(sign === "-" && (+(items.controls[index].controls['alreadyDisputedQuantity'].value) > 0)){
            items.controls[index].controls['alreadyDisputedQuantity'].setValue(parseInt(items.controls[index].controls['alreadyDisputedQuantity'].value) - 1);
            (+(items.controls[index].controls['alreadyDisputedQuantity'].value)) <= 0 ? this.deselectLineItem(index, items):'';
        }
        if (+items.controls[index].controls['alreadyDisputedQuantity'].value > 0) {
            this.formInvalid = false;
        } else if (+items.controls[index].controls['alreadyDisputedQuantity'].value === 0) {
            this.formInvalid = true;
        }
    }

    /*Check for max of 5 attachments */
    checkMaxAttachments(){
        if(this.uploader.queue){
          this.attachmentsLength = this.uploader.queue.length;
            if (this.attachmentsLength >= 5) {
                while (this.attachmentsLength > 5) {
                    this.uploader.queue[this.uploader.queue.length - 1].remove();
                    this.attachmentsLength--;
                }
            }
        }
    }
    /**
     * display alert box on reaching maximum no of attachmens = 5
     */
    maxAttachmentsAlert() {
        this.attachmentWarning.viewActionButtons = false;
        this.attachmentWarning.toggle = true;
        this.attachmentWarning.message = CommonMessage.attachmentMessage;
    }
    /**
     *Empty Method
        */
    noAction(){
    }
            /* clear form*/
    clearTicketForm(){
        this.clearFormAlert.viewActionButtons = true;
        this.clearFormAlert.toggle = true;
        this.clearFormAlert.message = CommonMessage.clearFormData;
    }
    /**
     *Dispute Reason for Entire dispute ticket
        */
    onDisputeReasonChange(){
        let disputereasonObj= this.disputeReasons.find(item => item.id === (+this.ticketCreateForm.controls['disputeReason'].value));
        this.disptueReason = disputereasonObj ? disputereasonObj.value : '';
        this.enableReason = false;
        this.ticketCreateForm.controls['orderReasonNotes'].setValidators(null);
        if((+this.ticketCreateForm.controls['disputeReason'].value) === DisputeReason.Other && (+this.ticketCreateForm.controls['disputeType'].value) === DisputeTypesEnums.Dispute_Total_Order){
            this.enableReason = true;
            this.ticketCreateForm.controls['orderReasonNotes'].setValidators(Validators.required);
        }
        this.ticketCreateForm.controls['orderReasonNotes'].updateValueAndValidity();
        if (this.ticketCreateForm.valid && (+this.ticketCreateForm.controls['disputeType'].value !== DisputeTypesEnums.Dispute_Individual_Order)) {
            this.disableCreate = false;
            this.formInvalid = false;
        }
    }
    /**
     *Dispute Reason change for individual dispute ticket
        */
    individualOrderReasonChange(index:number){
        const items: any = this.ticketCreateForm.get('items');
        this.enableReason = false;
        this.ticketCreateForm.controls['orderReasonNotes'].setValidators(null);
        if(items.controls[index].controls['ticketDisputeReasonId'].value === DisputeReason.Other && (+this.ticketCreateForm.controls['disputeType'].value) === DisputeTypesEnums.Dispute_Individual_Order
        && items.controls[index].controls['ticketDisputeReasonId'].validator){
            this.enableReason = true;
            this.ticketCreateForm.controls['orderReasonNotes'].setValidators(Validators.required);
        }
        this.ticketCreateForm.controls['orderReasonNotes'].updateValueAndValidity();
        const createTicketValues: any = this.ticketCreateForm.getRawValue();
        if (+createTicketValues.disputeType === DisputeTypesEnums.Dispute_Individual_Order) {
            const individualFormValues: any = createTicketValues.items;
            if (this.ticketCreateForm.valid && individualFormValues.filter(res => res.include === true).length) {
                this.disableCreate = false;
            }
        }
    }
    /* on source change*/
    onChangeOfSource(): void {
        if (this.ticketCreateForm.controls['source'].value === this.sourceTypesEnum.Email || this.ticketCreateForm.controls['source'].value === this.sourceTypesEnum.Online_Form) {
            this.phoneNumberFormat = '';
            this.ticketCreateForm.controls['sourceIdentifierValue']
                .setValue(this.distributorInfo ? this.distributorInfo.email : '', { emitModelToViewChange: false });
            this.ticketCreateForm.controls['sourceIdentifierValue'].setValidators([Validators.required, Utils.emailValidationRule]);
        } else {
            this.ticketCreateForm.controls['sourceIdentifierValue']
                .setValue(this.distributorInfo ? this.distributorInfo.contactNumber : '');
            this.ticketCreateForm.controls['sourceIdentifierValue'].setValidators([Validators.required, Utils.PhoneNumValidationRule]);
            this.phoneNumberFormat = this.countryPhoneFormat;
        }
        this.ticketCreateForm.controls['sourceIdentifierValue'].updateValueAndValidity();
    }

    assignToChange(){
        this.ticketCreateForm.controls['dueDate'].setValue('');
        if (this.ticketCreateForm.controls['assignTo'].value) {
            this.showDatePicker = true;
            this.ticketCreateForm.controls['dueDate'].enable();
            this.ticketCreateForm.controls['dueDate'].setValidators([Utils.validateDate]);
        } else {
            this.showDatePicker = false;
            this.ticketCreateForm.controls['dueDate'].disable();
            this.ticketCreateForm.controls['dueDate'].setValidators([]);
        }
        this.ticketCreateForm.controls['dueDate'].updateValueAndValidity();
    }

    /**
     * @description This method used to get users by search text
     * @date 2019-11-19
     * @memberof DisputeTicket
    */
   requestAutocompleteItems = (searchText: string): Observable<any> => {
    const userSearchList: CopyToUserResponse[] = [];
    const url = ApiUrlConstants.enrollmentApigwUrl + 'csp-agents/search?keyword=' + searchText + '&batchSize=10&pageNumber=1';
    const positionTimeout = 0;
    return this._http
      .get(url)
      .map(res => {
        const response: CopyToSearchResponse = res.json();
        if (response && response.content && response.content.length) {
          response.content.forEach(item => {
            const user = { value: item.firstName + ' ' + item.lastName + ' ' + item.username,
            display: item.firstName + ' ' + item.lastName + ' ' + item.username,
            displayName: item.firstName + ' ' + item.lastName, firstName: item.firstName,
                lastName: item.lastName, userId: item.userId, username: item.username
            };
            userSearchList.push(user);
          });
        }
        this.setOffsetPosition(positionTimeout);
        return userSearchList;
      });
  }

  /**
     * @description This method used to get users by search text
     * @date 2019-11-19
     * @memberof CreateWorkTicket
    */
    setOffsetPosition(positionTimeout: any): void {
        clearTimeout(positionTimeout);
        positionTimeout = setTimeout(() => {
            const tagInput: any = document.querySelector('.copy_to__block .ng2-tag-input__text-input');
            const dropdownElement: any = document.querySelector('.copy_to__block .ng2-dropdown-menu');
            if (tagInput) {
                dropdownElement.style.left = (12 + tagInput.offsetLeft) + 'px';
            }
        }, 0);
    }
    
     /**
      * storeing ordrinfo to session
      */
     navigateToOrderInfo(): void{
        if(this.orderInfo.webOrderNumber){
           this._cacheService.setSessionValue(CacheKey.ORDER_INFO_SESSION_CODE,this.orderInfoFornavigation);
            window.open(window.location.origin+'/customerservice/search', '_blank');
      
        }
   }
    /**
     * @description getting countries under operating country
     * @date 2020-03-06
     * @param {string} countryCode
     * @memberof CreateDisputeTicket
     */
    getAllCountries(countryCode: string): void {
        this._customerservice.getCountriesByOperatingCountry(countryCode).subscribe(response => {
            if (response && response.countriesUnderOperatingCountry.length) {
                this.allCountries = response.countriesUnderOperatingCountry.filter(country => country.countryCode === country.companyCode);
                if (this.countryCode) {
                    countryCode = this.countryCode;
                }
                const selectedCountry = this.allCountries.find(country => country.countryCode === countryCode);
                if (selectedCountry) {
                    this.ticketCreateForm.controls['country'].setValue(selectedCountry.countryCode);
                    this.IsoCodeThree = selectedCountry.companyCode;
                }
            }
        });
    }
    /**
     * @description injecting isocodethree of the selected country
     * @date 2020-03-06
     * @param {string} countryCode
     * @memberof CreateDisputeTicket
     */
    getCountryIsoCodeThree(countryCode: string, isCountryChange ?: Boolean) {
        if (this.allCountries) {
            this.IsoCodeThree = this.allCountries.find((country: any) => country.countryCode === countryCode).companyCode;
        }
        if (this.ticketCreateForm.controls['webOrderNumber'].value && isCountryChange) {
            this.getRecentOrderInformation();
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/customerservice/components/dispute-ticket-create.component.ts